module.exports = __webpack_public_path__ + "static/images/spray-bottle.403220c523ea8c99676ac06e0696758f.svg";